import React, { useState,useEffect } from "react";
import { apiUrl, brands } from "../config/config";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";

function Login() {
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  // Form states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Error message
  const [error, setError] = useState("");


    useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      window.location.href = "/account";
    }
  }, []);

  // Login Handler
// Login Handler
const handleLogin = async (e) => {
  e.preventDefault();
  setError("");

  try {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

     formData.append("brand", brands);
    const res = await fetch(`${apiUrl}/api/login`, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();

    if (!res.ok) {
      setError(data.message || "Invalid login credentials");
      return;
    }

    // Save user in localStorage
    localStorage.setItem("user", JSON.stringify(data.user));

    // Redirect to home using window.location.href
    window.location.href = "/";

  } catch (err) {
    console.log(err);
    setError("Something went wrong. Please try again.");
  }
};


  return (
    <>
          <SEO
                    title='Please Login'
                    description='Patch Designers For Hats'
                    keywords='Patch Designers For Hats'
                  />
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">

      {/* CARD */}
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">

        <h2 className="text-3xl font-bold text-center mb-6">Welcome Back</h2>
        <p className="text-center text-gray-600 mb-8">
          Login to continue to your account
        </p>

        {/* ERROR MESSAGE */}
        {error && (
          <div className="mb-4 bg-red-100 text-red-700 p-3 rounded-lg text-center">
            {error}
          </div>
        )}

        {/* FORM */}
        <form className="space-y-5" onSubmit={handleLogin}>

          {/* Email Field */}
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Email Address
            </label>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-black focus:outline-none"
              required
            />
          </div>

          {/* Password Field */}
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Password
            </label>

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-black focus:outline-none"
                required
              />

              {/* Show / Hide Password */}
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-3 text-gray-500 hover:text-black"
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-black text-white py-3 rounded-lg text-lg font-semibold hover:bg-gray-900 transition"
          >
            Login
          </button>
        </form>

        <div className="text-center mt-6 text-gray-500">or</div>

        <p className="text-center mt-4 text-sm">
          Don't have an account?{" "}
          <a href="/signup" className="text-black font-semibold hover:underline">
            Create Account
          </a>
        </p>

      </div>
    </div>
    </>
  );
}

export default Login;
